import * as React from 'react';
import { Spinner } from 'components/Spinner';
import { prerenderedLoadable } from 'utils/prefetch';
const PrivacyPolicyPage = prerenderedLoadable(() => import(/* webpackChunkName: "PrivacyPolicy" */ 'containers/Content/PrivacyPolicy/PrivacyPolicy'));
export const PrivacyPolicy = () => (React.createElement(React.Suspense, { fallback: React.createElement(Spinner, null) },
    React.createElement(PrivacyPolicyPage, null)));
